$(document).ready(function () {

    $('.rte img').addClass(
        function(){
            var floated = $(this).css('float');
            return floated ? 'img-' + floated : '';
        });

    $(".hero-slide-cover").css('background-image', function () {
        var bg = ('url(' + $(this).data("image-src") + ')');
        return bg;
    });
    $('.pro-slider').slick({
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        dots: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: false,
                    arrows: false
                }
            }
        ]
    });
    $('.hero-slider').slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 1000,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1200
    });
    $(".rp-close").click(function(){
        $(".navigation").removeClass("nav-show" ,2000);
    });
    $(".menu-rp").click(function(){
        $(".navigation").delay(1000).toggleClass("nav-show" ,2000);
    });
    $('.suggestions-pro').slick({
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1081,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            }
        ]
    });
    jQuery(document).ready(function($) {
        var alterClass = function() {
            var ww = document.body.clientWidth;
            if (ww < 400) {
                $('.product').removeClass('suggestions-pro');
            }
        };
    });

    $('.best-seller-slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1200,
        responsive: [
            {
                breakpoint: 1081,
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }
        ]
    });
    $('.logo-slider').slick({
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 8,
        lazyLoad: 'ondemand',
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 1200,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow:6,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    arrows: false
                }
            },
            {
                breakpoint: 541,
                settings: {
                    slidesToShow:4,
                    arrows: false
                }
            },
            {
                breakpoint: 481,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 321,
                settings: {
                    slidesToShow: 2,
                    arrows: false
                }
            }
        ]
    });
    $('.product-gallery').slick({
        arrows: false,
        dots: false,
        speed: 1000,
        slidesToShow: 1,
        fade:true,
        slidesToScroll: 1,
        autoplay: false,
        asNavFor:'.product-gallery-nav'
    });
    $('.product-gallery-nav').slick({
        arrows: true,
        dots: false,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical:true,
        autoplay: false,
        asNavFor:'.product-gallery',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    vertical:false
                }
            }
        ]
    });

    $('.collection-filter fieldset button').click(function () {
        $(this).next('.filter-dropdown').slideToggle(200);
        $(this).toggleClass('active');
    });

    /*if($(window).width() <= 767) {
        $('.footer-links h5').click(function () {
            $(this).next().slideToggle(200);
            $(this).toggleClass('active');
        });
    }*/
    $('.footer-col h4').click(function () {
        $(this).next('ul').slideToggle();
        $(this).toggleClass('panel-active');
    });
    $('.custom-select').click(function() {
        $(this).next('.dropdown-box').slideToggle(300);
    });

    $('.menu-opener').click(function () {
        $('.side-navigation, .overlay').addClass('active');
        $('body').addClass('active');
    });
    $('.search-link a').click(function () {
        $('.search-box').addClass('active');
    });

    $('.overlay, .close-btn').click(function () {
        $('.side-navigation, .overlay, .search-box , .size-chart , body').removeClass('active');
        $('body').removeClass('chart-active');
    });

    $('.size-mod').click(function () {
        $('.size-chart').addClass('active');
        $('.overlay').addClass('active');
        $('body').addClass('chart-active');
    });

    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".tab_content").hide();
    $(".tab_content:first").show();

    /* if in tab mode */
    $("ul.tabs li").click(function() {

        $(".tab_content").hide();
        var activeTab = $(this).attr("rel");
        $("#"+activeTab).fadeIn();

        $("ul.tabs li").removeClass("active");
        $(this).addClass("active");

        $(".tab_drawer_heading").removeClass("d_active");
        $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

    });
    /* if in drawer mode */
    $(".tab_drawer_heading").click(function() {

        $(".tab_content").hide();
        var d_activeTab = $(this).attr("rel");
        $("#"+d_activeTab).fadeIn();

        $(".tab_drawer_heading").removeClass("d_active");
        $(this).addClass("d_active");

        $("ul.tabs li").removeClass("active");
        $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
    /* Extra class "tab_last"
       to add border to right side
       of last tab */
    $('ul.tabs li').last().addClass("tab_last");


    $('.edit-address').click(function () {
        $('.edit-address-box').slideToggle('350');
    });
	
	/*Scroll to top when arrow up clicked BEGIN*/
    $(window).scroll(function() {
        var height = $(window).scrollTop();
        if (height > 100) {
            $('#backtotop').fadeIn();
        } else {
            $('#backtotop').fadeOut();
        }
    });
    $(document).ready(function() {
        $("#backtotop").click(function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

    });
    /*Scroll to top when arrow up clicked END*/

});
